@if (src() && !failed()) {
  <img
    [src]="src()"
    [alt]="name() ?? ''"
    loading="lazy"
    decoding="async"
    (error)="failed.set(true)"
  />
} @else {
  <span aria-hidden="true">{{ initials() }}</span>
}
